/**
 * OneBase Routes
 * Define todas las rutas del OneBase con protección de autenticación
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';

// Pages
import OneBaseDashboard from '../pages/OneBaseDashboard';
import OneBaseProyectos from '../pages/OneBaseProyectos';
import OneBaseClientes from '../pages/OneBaseClientes';
import OneBaseLineasNegocio from '../pages/OneBaseLineasNegocio';
import OneBasePresupuestos from '../pages/OneBasePresupuestos';
import OneBaseOrdenes from '../pages/OneBaseOrdenes';
import AvanceGastarAcumulado from '../pages/AvanceGastarAcumulado';
import GanttAcumulado from '../pages/GanttAcumulado';
import AdminCatalogo from '../pages/AdminCatalogo';
import AdminCatalogoMejorado from '../pages/AdminCatalogoMejorado';
import MaestroAreas from '../pages/maestros/MaestroAreas';
import MaestroPartidas from '../pages/maestros/MaestroPartidas';
import MaestroTiposRecurso from '../pages/maestros/MaestroTiposRecurso';
import MaestroRecursos from '../pages/maestros/MaestroRecursos';
import OrdenesCompraPage from '../pages/OrdenesCompraPage';
import GuiasDespachoPage from '../pages/GuiasDespachoPage';
import FlujoProcesosPage from '../pages/FlujoProcesosPage';
import ProveedoresPage from '../pages/ProveedoresPage';
import ClaseRecursosPage from '../pages/ClaseRecursosPage';
import GestionEquipos from '../pages/GestionEquipos';
import DocumentosLegalesPage from '../pages/DocumentosLegalesPage';
import VouchersPage from '../pages/VouchersPage';
import ParametrizacionContablePage from '../pages/ParametrizacionContablePage';
import SolicitudesPage from '../pages/SolicitudesPage';
import InstagramTrackerPage from '../pages/InstagramTrackerPage';
import TikTokTrackerPage from '../pages/TikTokTrackerPage';

const OneBaseRoutes = ({ isAuthenticated, loading }) => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <OneBaseDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/proyectos/*"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <OneBaseProyectos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/clientes/*"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <OneBaseClientes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/lineas-negocio/*"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <OneBaseLineasNegocio />
          </ProtectedRoute>
        }
      />
      <Route
        path="/presupuestos/*"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <OneBasePresupuestos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ordenes/*"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <OneBaseOrdenes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/avance-gastar/*"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <AvanceGastarAcumulado />
          </ProtectedRoute>
        }
      />
      <Route
        path="/gantt/*"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <GanttAcumulado />
          </ProtectedRoute>
        }
      />
      <Route
        path="/catalogo"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <AdminCatalogoMejorado />
          </ProtectedRoute>
        }
      />
      <Route
        path="/catalogo-jerarquico"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <AdminCatalogo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/maestros/areas"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <MaestroAreas />
          </ProtectedRoute>
        }
      />
      <Route
        path="/maestros/partidas"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <MaestroPartidas />
          </ProtectedRoute>
        }
      />
      <Route
        path="/maestros/tipos-recurso"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <MaestroTiposRecurso />
          </ProtectedRoute>
        }
      />
      <Route
        path="/maestros/recursos"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <MaestroRecursos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/maestros/proveedores"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <ProveedoresPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/maestros/clase-recursos"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <ClaseRecursosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/maestros/equipos"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <GestionEquipos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/flujo-procesos"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <FlujoProcesosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/documentos/solicitudes"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <SolicitudesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/documentos/ordenes-compra"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <OrdenesCompraPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/documentos/guias-despacho"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <GuiasDespachoPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/documentos/legales"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <DocumentosLegalesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/contabilidad/vouchers"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <VouchersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/contabilidad/parametrizacion"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <ParametrizacionContablePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/instagram/tracker"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <InstagramTrackerPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tiktok/tracker"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}>
            <TikTokTrackerPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default OneBaseRoutes;
